/**
 * The twelve shelves kikik.id is being built for.
 *
 * All twelve exist from day one so the platform's shape is honest and legible;
 * eleven of them are empty, and the portal says so in plain words rather than
 * hiding them. `size` is not decoration: the shelf that actually holds a
 * released game is the one that reads largest on the homepage.
 */

import { CATEGORY_IDS } from "./types.js";
import type { Category, CategoryId } from "./types.js";

export const CATEGORIES: readonly Category[] = [
  {
    id: "board-strategy",
    nameKey: "portal.category.board-strategy.name",
    blurbKey: "portal.category.board-strategy.blurb",
    motif: "board",
    accent: "jade",
    size: "hero",
  },
  {
    id: "puzzle-brain",
    nameKey: "portal.category.puzzle-brain.name",
    blurbKey: "portal.category.puzzle-brain.blurb",
    motif: "puzzle",
    accent: "grape",
    size: "wide",
  },
  {
    id: "cards-classics",
    nameKey: "portal.category.cards-classics.name",
    blurbKey: "portal.category.cards-classics.blurb",
    motif: "cards",
    accent: "berry",
    size: "tall",
  },
  {
    id: "arcade-casual",
    nameKey: "portal.category.arcade-casual.name",
    blurbKey: "portal.category.arcade-casual.blurb",
    motif: "arcade",
    accent: "mango",
    size: "wide",
  },
  {
    id: "action",
    nameKey: "portal.category.action.name",
    blurbKey: "portal.category.action.blurb",
    motif: "bolt",
    accent: "flame",
    size: "small",
  },
  {
    id: "adventure",
    nameKey: "portal.category.adventure.name",
    blurbKey: "portal.category.adventure.blurb",
    motif: "compass",
    accent: "pine",
    size: "tall",
  },
  {
    id: "sports-racing",
    nameKey: "portal.category.sports-racing.name",
    blurbKey: "portal.category.sports-racing.blurb",
    motif: "flag",
    accent: "sky",
    size: "small",
  },
  {
    id: "simulation",
    nameKey: "portal.category.simulation.name",
    blurbKey: "portal.category.simulation.blurb",
    motif: "dial",
    accent: "steel",
    size: "tall",
  },
  {
    id: "multiplayer-party",
    nameKey: "portal.category.multiplayer-party.name",
    blurbKey: "portal.category.multiplayer-party.blurb",
    motif: "confetti",
    accent: "punch",
    size: "wide",
  },
  {
    id: "music-rhythm",
    nameKey: "portal.category.music-rhythm.name",
    blurbKey: "portal.category.music-rhythm.blurb",
    motif: "wave",
    accent: "violet",
    size: "wide",
  },
  {
    id: "family",
    nameKey: "portal.category.family.name",
    blurbKey: "portal.category.family.blurb",
    motif: "home",
    accent: "apricot",
    size: "wide",
  },
  {
    id: "learn-explore",
    nameKey: "portal.category.learn-explore.name",
    blurbKey: "portal.category.learn-explore.blurb",
    motif: "flask",
    accent: "lagoon",
    size: "tall",
  },
];

const BY_ID = new Map<CategoryId, Category>(CATEGORIES.map((category) => [category.id, category]));

export function getCategory(id: string): Category | null {
  return BY_ID.get(id as CategoryId) ?? null;
}

export function isCategoryId(value: unknown): value is CategoryId {
  return typeof value === "string" && (CATEGORY_IDS as readonly string[]).includes(value);
}
